var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.451,
    height: 20.451,
    viewBox: "0 0 20.451 20.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-400 -133.801)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7",
    transform: "translate(400.627 137.851)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 3.136,
    cy: 3.15,
    rx: 3.136,
    ry: 3.15,
    transform: "translate(7.05 3.465)",
    fill: "#2d62ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6269",
    "data-name": "Path 6269",
    d: "M20.061,90.777c-2.411-2.926-6.06-5.743-9.874-5.743S2.722,87.853.313,90.777a1.374,1.374,0,0,0,0,1.745,20.458,20.458,0,0,0,3.572,3.394c4.271,3.123,8.324,3.13,12.6,0a20.457,20.457,0,0,0,3.572-3.394A1.375,1.375,0,0,0,20.061,90.777ZM10.187,87.24A4.41,4.41,0,1,1,5.8,91.65,4.406,4.406,0,0,1,10.187,87.24Z",
    transform: "translate(0 -85.035)",
    fill: "#2d62ed"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.4d479790ec8b6a5bb620af38505dee66.svg";
export { ForwardRef as ReactComponent };